import {sendSlackMessageTracked} from "./notifications";

export default function submitForm(formType, formData) {
    // Form types proposal_request_main_hero, proposal_request_secondary_hero, win_free_month, contact_us
    sendSlackMessageTracked(`💰Form Submission!\nForm Type: ${formType}\nsubmitForm${JSON.stringify(formData)}`);
}